import React from "react"

export default function CircularSpinner() {
  return (
    <div className="spinner">
     
    </div>
  )
}
